export default __webpack_public_path__ + "static/media/productsImage6.e3b89eb6.svg";